import React, { useState } from "react";
import {
    Box,
    Card,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
} from "@mui/material";
import COLORS from "../../../../../constants/colors";

const TransactionsHistory = ({ transactions }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Card
            sx={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                border: "1px solid rgba(0,0,0,0.05)",
                p: 3,
                mt: 3,
            }}
        >
            <Typography
                variant="h6"
                sx={{ mb: 3, fontSize: "1.1rem", fontWeight: 800, color: "#1a1a2e", letterSpacing: "-0.3px" }}
            >
                Transactions History
            </Typography>

            {transactions.length === 0 ? (
                <Typography
                    variant="body2"
                    sx={{
                        textAlign: "center",
                        color: "#777",
                        mt: 2,
                        mb: 2,
                        fontSize: "0.85rem",
                        p: 2,
                        border: "1px dashed #ddd",
                        borderRadius: 1,
                        bgcolor: "#fdfdfd",
                    }}
                >
                    No transactions found. Your campaign deposits and withdrawals will appear here.
                </Typography>
            ) : (
                <>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            overflowX: 'auto',
                        }}
                    >
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead sx={{ bgcolor: "#f5f7fa" }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: 'nowrap' }}>
                                        Type
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: 'nowrap' }}>
                                        Fundraise
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: 'nowrap' }}>
                                        Amount
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: 'nowrap' }}>
                                        Status
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: 'nowrap' }}>
                                        Date
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {transactions
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((transaction) => (
                                        <TableRow
                                            key={transaction.id}
                                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                        >
                                            <TableCell sx={{ fontSize: "0.8rem", whiteSpace: 'nowrap' }}>
                                                {transaction.type}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: "0.8rem", whiteSpace: 'nowrap' }}>
                                                {transaction.fundraise}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: "0.8rem", whiteSpace: 'nowrap' }}>
                                                UGX {transaction.amount.toLocaleString()}
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontSize: "0.8rem",
                                                    py: 1,
                                                    color:
                                                        transaction.status === "Completed"
                                                            ? "green"
                                                            : transaction.status === "Pending"
                                                                ? "orange"
                                                                : "red",
                                                    fontWeight: "bold",
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {transaction.status}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: "0.8rem", whiteSpace: 'nowrap' }}>
                                                {formatTimestamp(transaction.date)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: 2,
                            px: 1,
                        }}
                    >
                        <Typography variant="body2" sx={{ fontSize: "0.8rem", color: "#666" }}>
                            Showing {page * rowsPerPage + 1} -{" "}
                            {Math.min((page + 1) * rowsPerPage, transactions.length)} of{" "}
                            {transactions.length} transactions
                        </Typography>
                        <TablePagination
                            component="div"
                            count={transactions.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[5, 10, 25]}
                            sx={{
                                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions":
                                    {
                                        fontSize: "0.8rem",
                                    },
                            }}
                        />
                    </Box>
                </>
            )}
        </Card>
    );
};

export default TransactionsHistory;